import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";
import Reveal from "@/components/base/Reveal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            FAQ
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px] md:leading-[1.25]">
            投稿之前，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            关于匿名、核实节奏与内容边界的高频问题，都在这里。如果还有别的顾虑，欢迎直接来信。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <li key={item.q}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 py-5 text-left"
                    >
                      <span
                        className={`font-heading text-base font-semibold transition-colors md:text-lg ${
                          open ? "text-primary-700" : "text-foreground-900"
                        }`}
                      >
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                          open ? "ri-subtract-line text-primary-600" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      />
                    </button>
                  </h3>
                  <div
                    className={`grid overflow-hidden transition-all duration-300 ${
                      open ? "grid-rows-[1fr] pb-6 opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <p className="min-h-0 pr-8 text-sm leading-8 text-foreground-600">{item.a}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}